"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appReview = void 0;
exports.appReview = function (axios) { return ({
    putAppsAppNoReview: function (request) {
        var appNo = request.pathParams.appNo;
        return axios.put("/apps/" + appNo + "/review", request.data);
    },
    putAppsAppNoReviewWithdraw: function (request) {
        var appNo = request.pathParams.appNo;
        return axios.put("/apps/" + appNo + "/review-withdraw");
    }
}); };
